export default [
    { value: 2, label: 'Admin' },
    { value: 1, label: 'Manager' },
    { value: 0, label: 'Member' }
];

